export default __webpack_public_path__ + "static/media/cert-market-hkgcsmeaa.366e8073.jpg";